/**
 * @file PPD Print Package Purchase Modal Container.
 */

import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import PurchasePpdPrintPackageModal from '../../components/purchase/PurchasePpdPrintPackageModal';
import { AlbumForPpdPurchase } from '../../graphql/queries/albums';
import { openModal } from '../../actions/modal-actions';

const withAlbumForPpdPurchase = graphql(AlbumForPpdPurchase, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album, loading } }) => ({
    album,
    loading,
  }),
});

const mapStateToProps = ({ ppdPurchase }) => ({
  cart: ppdPurchase.cart,
});

const mapDispatchToProps = {
  openModal,
};

export default compose(
  withRouter,
  withAlbumForPpdPurchase,
  connect(mapStateToProps, mapDispatchToProps),
)(PurchasePpdPrintPackageModal);
